import api from "../../common/dependencies/utils/Api";
import {
  GET_A_MENTOR_FORM,
  LOGIN_DATA,
  REGISTER_MENTOR,
  SAVE_DRAFT_MENTOR,
  REGISTER_STARTUP,
  GET_SIGNAL_MENTOR_DATA,
  VIEW_PREDEFINED_OPTIONS,
  REGISTER_EDIT_MENTOR,
  VIEW_MENTOR_APPLICATION_DATA,
} from "../../common/constants/ApplicationUrl";

export const GetMentorFormServices = {
  getMentorFormServices() {
    return api
      .GET(`${GET_A_MENTOR_FORM}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },

  registerMentor(params, email, action) {
    //
    

    return api
      .POSTDATA(
        action === "VERIFIED" ? REGISTER_EDIT_MENTOR : REGISTER_MENTOR,
        params
      )
      .then((response) => {
        //call view mentor to
        // alert(email)
        let param1 = {
          email_id: email,
        };
        api
          .POST(`${GET_SIGNAL_MENTOR_DATA}`, param1)
          .then((responseData) => {
            const { data: { responseCode, data, success } = {} } = responseData;
            if (responseData) {
              
              // localStorage.setItem("SavedLoggedInData")
              localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
            } else {
            }
          })
          .catch((e) => {
            return Promise.reject(e);
          });

        return response;
      });
  },
  savedraftMentor(params) {
    //

    return api.POSTDATA(SAVE_DRAFT_MENTOR, params).then((response) => {
      //
      return response;
    });
  },
  getViewMentorApplicationData(params) {
    return api
      .POST(`${VIEW_MENTOR_APPLICATION_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getPredefineOptionsList() {
    return api
      .GET(`${VIEW_PREDEFINED_OPTIONS}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
};